<fs-tab-bar-offline [titlePage]="pageTitle"></fs-tab-bar-offline>

<div id="page-sign-block" [ngClass]="{'report-error': isErrorReport}">
  <div id="main-sign-block" [ngClass]="{'report-error': isErrorReport}">
    <fs-message-card cardClass="success" *ngIf="isErrorSent && isBlockingError === false">
      <div header> Le message suivant a bien été envoyé à votre conseiller commercial </div>
      <div body>
        {{ errorText }}
        <p>Ces modifications n’impactent ni la prestation ni son prix. Vous pouvez donc signer le bon de commande en tout sérénité.</p>
      </div>
    </fs-message-card>

    <div id="header-sign-block" *ngIf="idStatus === signStatus.INPROGRESS">
      <h2>Vérifiez les informations de votre devis</h2>
      <p id="instructions">
        Suite à votre échange avec votre conseiller, veuillez trouver ci-dessous la proposition
        commerciale.<br />
        Prenez le temps de vérifier la validité des informations avant de poursuivre.
      </p>
    </div>

    <div *ngIf="isOrderAndSepaSign" id="order-pdf-block" [ngClass]="{'report-error': isErrorReport}">
      <div *ngIf="!returnSignature" [ngSwitch]="idStatus">
        <div id="in-progress-state" *ngSwitchCase="signStatus.INPROGRESS"
          [ngClass]="{'unblocking-error': isErrorSent && isBlockingError === false}">
          <iframe id="order-pdf" [src]="unsignedBdcPdf" frameborder="0"></iframe>
        </div>
        <div *ngSwitchCase="signStatus.CANCELED">
          <h5 *ngIf="!isErrorSent">Vous avez déjà refusé ce bon de commande, nous vous invitons à contacter votre
            conseiller commercial.
          </h5>
          <div *ngIf="isErrorSent">
            <div class="error-sent-head">
              Votre message a bien été envoyé !
            </div>
            <div class="error-sent-text">
              <div uiSvg source="assets/images/perfect-hand"></div>
              <div>
                <h1>Nous allons corriger cette erreur</h1>
                <p>
                  Votre conseiller commercial vous recontactera au plus vite pour corriger le bon de commande.<br>
                  Vous recevrez ensuite un nouvel email vous invitant à signer le bon de commande mis à jour avec les
                  modifications demandées.<br>
                  L’équipe SeLoger vous souhaite une bonne journée.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div *ngSwitchCase="signStatus.SIGNED">
          <h5>Vous avez déjà signé ce bon de commande, merci de votre confiance !</h5>
        </div>
        <div *ngSwitchCase="signStatus.EXPIRED">
          <h5>Votre bon de commande a expiré, nous vous invitons à contacter votre conseiller commercial.</h5>
        </div>
        <div *ngSwitchDefault>
          <h5>Une erreur est survenue, nous vous invitons à rééssayer ultérieurement.</h5>
        </div>
      </div>
    </div>

    <div *ngIf="!isOrderAndSepaSign">
      <div [ngSwitch]="signatureService.errorState">
        <div *ngSwitchCase="signatureState.ERROR">
          <h5>Une erreur est survenue. Nous vous invitons à rafraichir la page (en appuyant sur la touche F5).</h5>
        </div>

        <div *ngSwitchCase="signatureState.NOT_FOUND">
          <h5>Une erreur est survenue. Le lien de signature a expiré.</h5>
        </div>

        <div *ngSwitchDefault>
          <div [ngSwitch]="idStatus">
            <div *ngSwitchCase="signStatus.INPROGRESS">
              <fs-purchase-orders-sign-iframe [isErrorReport]="isErrorReport" *ngIf="!returnSignature">
              </fs-purchase-orders-sign-iframe>
            </div>

            <div *ngSwitchCase="signStatus.SIGNED">
              <div *ngIf="returnSignature">
                <fs-message-card cardClass="success" *ngIf="returnSignature">
                  <div header> Votre bon de commande a bien été signé ! </div>
                  <div body>
                    Votre bon de commande a été envoyé à votre conseiller commercial.
                    <p><b>Merci de votre confiance !</b></p>
                  </div>
                </fs-message-card>
              </div>

              <div *ngIf="!returnSignature">
                <h5>Vous avez déjà signé ce bon de commande. Merci de votre confiance !</h5>
              </div>
            </div>

            <div *ngSwitchCase="signStatus.CANCELED">
              <div *ngIf="returnSignature">
                <fs-message-card cardClass="alert" *ngIf="returnSignature">
                  <div header> Votre refus a été pris en compte ! </div>
                  <div body>
                    Contactez votre conseiller commercial pour établir un nouveau bon de commande.
                    <p><b>Merci de votre confiance !</b></p>
                  </div>
                </fs-message-card>
              </div>

              <div *ngIf="!returnSignature">
                <h5 *ngIf="!isErrorSent">Vous avez déjà refusé ce bon de commande ou il a expiré. Nous vous invitons à
                  contacter
                  votre conseiller commercial.</h5>
                <div *ngIf="isErrorSent">
                  <div class="error-sent-head">
                    Votre message a bien été envoyé !
                  </div>
                  <div class="error-sent-text">
                    <div uiSvg source="assets/images/perfect-hand"></div>
                    <div>
                      <h1>Nous allons corriger cette erreur</h1>
                      <p>
                        Votre conseiller commercial vous recontactera au plus vite pour corriger le bon de commande.<br>
                        Vous recevrez ensuite un nouvel email vous invitant à signer le bon de commande mis à jour avec
                        les modifications demandées.<br>
                        L’équipe SeLoger vous souhaite une bonne journée.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div *ngSwitchCase="signStatus.EXPIRED">
              <h5>Vous avez déjà refusé ce bon de commande ou il a expiré. Nous vous invitons à contacter votre
                conseiller commercial.</h5>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="idStatus === signStatus.INPROGRESS" class="btn-block">
      <button class='ui-btn secondary-btn large' (click)="openReportError()" [disabled]="isErrorReport">Signaler une
        erreur</button>
      <button class='ui-btn primary-btn' (click)="goToSepaLink()" [disabled]="isErrorReport"
        [hidden]="!isOrderAndSepaSign">Continuer</button>
    </div>
  </div>

  <div id="report-error-block" *ngIf="isErrorReport">
    <h2>Signaler une erreur</h2>
    <p>
      L'erreur concerne-t-elle le prix ou une information juridique comme le SIRET,
      la raison sociale ou le code postal du signataire ou du facturé ?
    </p>
    <mat-radio-group [(ngModel)]="isBlockingError">
      <mat-radio-button id="radio-btn-yes" color="primary" [value]="true">Oui</mat-radio-button>
      <mat-radio-button color="primary" [value]="false">Non</mat-radio-button>
    </mat-radio-group>
    <div class="msg-info" *ngIf="isBlockingError">
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      Cette demande de modification porte sur le prix ou une donnée juridique par conséquent, le bon de commande est
      caduc.
      A l'envoi de votre message, nous annulerons le bon de commande ici présent et votre conseiller reviendra
      rapidement vers vous avec un nouveau bon de commande mis à jour.
    </div>
    <div class="msg-info" *ngIf="isBlockingError === false">
      <fa-icon [icon]="faInfoCircle"></fa-icon>
      Cette demande de modification n'invalide pas la proposition commerciale, nous enverrons votre message à
      votre conseiller commercial afin d'effectuer les modifications sur nos bases.
      Parallèlement, vous pouvez poursuivre votre parcours de signature.
    </div>
    <p>
      Veuillez préciser les modifications à apporter:
    </p>
    <fieldset id="error-textarea">
      <legend>Demande de modification</legend>
      <textarea [(ngModel)]="errorText" name="error-text" rows="10"></textarea>
    </fieldset>
    <div class="btn-block">
      <button class='ui-btn secondary-btn' (click)="isErrorReport = false">Annuler</button>
      <button class='ui-btn primary-btn' (click)="sendError()"
        [disabled]="isBlockingError === undefined || !errorText">Envoyer</button>
    </div>
  </div>
</div>

<ngx-smart-modal #welcomeMsgOrderSepaSignModal identifier="welcomeMsgOrderSepaSignModal" customClass="nsm-centered">
  <div class="modal-header">
    <h2>Bienvenue</h2>
  </div>

  <div class="modal-content">
    <p>
      Pour finaliser votre souscription, cela va se dérouler en trois étapes:
    </p>
    <ol>
      <li>
        <b>Vérifiez les informations</b> de votre devis : ce sont à ces adresses que nous vous enverrons
        toutes les informations d’activation
      </li>
      <li>
        <b>Complétez votre mandat SEPA</b> afin de faciliter vos paiements futurs
      </li>
      <li>
        <b>Signez vos documents</b> en ligne grâce à la signature électronique
      </li>
    </ol>
    <p>
      En cas de besoin, n'hésitez pas à contacter votre conseiller commercial afin qu'il réponde à vos
      questions.
    </p>
  </div>

  <div class="modal-footer">
    <button class="ui-btn primary-btn" (click)="welcomeMsgOrderSepaSignModal.close()">Continuer</button>
  </div>
</ngx-smart-modal>
